import React, { useEffect } from "react";

import DatatablePage from "../../../layout/datatable-pages/investors";
import { fetchData, getInvestorsFieldsArray } from "../../../utils/helpers";
import { props } from "../../datatable/props";
import useDatatable from "../../hooks/useDatatable";

import "../../data/datatable-pages.css";
import { useSupabaseApp } from "../../../SupabaseApp";

/**
 * VeryEarlyStage Component (Very Early Stage Funding Sourcing)
 * 
 * Browse and discover very early stage funding sources for pre-seed and seed stage companies.
 * Connect with angels, accelerators, and early stage investors. Search through 43+ investor
 * attributes. Displays investor statistics and investment preferences. Requires authentication.
 * 
 * @returns {JSX.Element} Datatable page with very early stage funding sources
 */
const VeryEarlyStage = () => {
  // Array of investor field keys to display in the datatable (43 fields for sourcing)
  const fieldKeys = [
    "name",
    "investorType",
    "description",
    "numOfFailedInvestments",
    "lossOnInvestments",
    "shutteredPortfolioCompanies",
    "numOfExit",
    "exitValue",
    "reputation",
    "location",
    "investmentStage",
    "investmentTrackRecord",
    "assets",
    "investmentRange",
    "sweetSpot",
    "investmentFocus",
    "investmentGeography",
    "numOfInvestments",
    "numOfLeadInvestments",
    "numOfFollowOnInvestments",
    "numOfCoInvestments",
    "numOfAcquisitions",
    "boardSeats",
    "numOfFunds",
    "limitedPartners",
    "coInvestors",
    "numofPartners",
    "partners",
    "numOfEmployeesObj",
    "management",
    "boardMembers",
    "founders",
    "email",
    "socialMedia",
    "website",
    "phone",
    "address",
    "entityType",
    "legalName",
    "primaryBusinessName",
    "formerlegalName",
    "founded",
    "stockSymbol",
  ];

  const fields = getInvestorsFieldsArray(fieldKeys);

  const { datatableProps } = useDatatable();

  // realm functions declaration
  const { currentUser, supabase, getUserTier } = useSupabaseApp();

  // check if user is logged in or not
  if (!currentUser) {
    throw new Error(`Must be logged in`);
  }

  // params for functions
  const params = {
    supabase,
    ...datatableProps,
    getData: "getVeryEarlyStageFunding",
    collection: "investors",
    title: "Very early stage funding",
    datatipText:
      "Search for funding with our founder-friendly collection of angel investor, micro venture capital, and other very-early stage funding sources.",
    statsArray: [
      {
        actualName: "financingSources",
        displayName: "Financing sources",
        total: "10,000",
      },
    ],
    placeholderText: "Search from very early stage funding",
    fields: fields,
    getCompanyDetailsForExpand: "getCompanyDetailsForExpand",
  };

  // fetch data on page load
  useEffect(() => {
    fetchData(params);
  }, []);

  return <DatatablePage props={props(params)} />;
};

export default VeryEarlyStage;
